import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APP_OPTIONS, AppOptions } from '@unleashed/common/config';
import { ApiService, ServiceBase } from '@unleashed/api/common';
import { AccountLookup, CompleteProvisionalAccountRequest, OtpVerifyResponse } from '@unleashed/models/account';

@Injectable({
  providedIn: 'root'
})
export class ThriveScoreApiService extends ServiceBase {

  subnav = 'thrivescore';

  constructor(
    @Inject(APP_OPTIONS) appOptions: AppOptions,
    private apiService: ApiService,
    private http: HttpClient
  ) {
    super(appOptions.unleashedApiUrl);
  }

  sendOtp(email: string): Observable<void> {
    return this.apiService.post<void, { email: string }>(this.buildUrl('auth', 'otp', 'send'), { email });
  }

  verifyOtp(email: string, code: string): Observable<OtpVerifyResponse> {
    return this.http
      .post<{ data?: OtpVerifyResponse } | OtpVerifyResponse>(this.buildUrl('auth', 'otp', 'verify'), { email, code })
      .pipe(map(response => (response as { data?: OtpVerifyResponse }).data ?? response as OtpVerifyResponse));
  }

  completeAccount(accountId: number, request: CompleteProvisionalAccountRequest, otpToken: string): Observable<AccountLookup> {
    return this.apiService.post<AccountLookup, CompleteProvisionalAccountRequest>(
      this.buildUrl('account', accountId, 'complete'),
      request,
      {
        headers: new HttpHeaders({ Authorization: `Bearer ${otpToken}` })
      }
    );
  }
}
